export const ResponseStatus = {
    SUCCESS:"SUCCESS",
    WARN:"WARN",
    ERROR:"ERROR",
    LOADING: "LOADING",
    NO_INTERNET: "NO_INTERNET"
};


// WEBPACK FOOTER //
// ./src/components/utils/ResponseStatus.js